import { render, staticRenderFns } from "./DocumentRuleDash.vue?vue&type=template&id=45674cc8&scoped=true&"
import script from "./DocumentRuleDash.vue?vue&type=script&lang=js&"
export * from "./DocumentRuleDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45674cc8",
  null
  
)

export default component.exports